const styles = theme => ({
    "@global": {
        html: {
            [theme.breakpoints.down("sm")]: {
                fontSize: 10
            },
            [theme.breakpoints.between("sm","md")]: {
                fontSize: 14
            },
            
        }
    }
});

export default styles;
